var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('div',{staticClass:"container"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"logo",attrs:{"src":require("../../assets/img/logo.png"),"alt":"Logo"}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }